module.exports = __webpack_public_path__ + "static/media/monica.77280ae6.jpeg";